import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RefreshScalelineService } from 'app/core/services/refresh-scaleline/refresh-scaleline.service';
import { SalaryScaleService } from 'app/core/services/salary-scale.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'dialog-delete-scale-batch',
  templateUrl: './dialog-delete-scale-batch.component.html',
  styleUrls: ['./dialog-delete-scale-batch.component.scss']
})
export class DialogDeleteScaleBatchComponent implements OnInit {

  isLoading: boolean = false;
  
  constructor(public dialogRef: MatDialogRef<DialogDeleteScaleBatchComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
              private salaryScaleService: SalaryScaleService, private refrehScaleLineService: RefreshScalelineService,
              private toastr: ToastrService) { }

  ngOnInit(): void {
    
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  deleteSelectedElement() {
    this.isLoading = true;
    this.salaryScaleService.deleteScaleLine(this.data.selectedIds).subscribe({
      next: (res) => {
        this.refrehScaleLineService.emitRefresh(this.data.selectedIds);
        this.notify('Scale line deleted successfully!', 'success');
        Promise.resolve().then(() => {
          this.isLoading = false;
          this.dialogRef.close();
        });
      },
      error: (err) => {
        this.isLoading = false;
        console.error('Error deleting element:', err);
        this.notify('Failed to delete scale line. Please try again.', 'error');
      },
    });
  }

  private notify(text: string, type: 'success' | 'error'): void {
    this.toastr.success(`<span class="now-ui-icons ui-1_bell-53"></span> ${text}`, '', {
      timeOut: 3000,
      closeButton: true,
      enableHtml: true,
      toastClass: type === 'success' ? 'alert alert-success alert-with-icon' : 'alert alert-danger alert-with-icon',
      positionClass: 'toast-top-center',
    });
  }
}
